<template>
  <div>
    <div class="loader" v-if="loading"></div>

    <div v-else>
      <div class="justify-content-center">
        <!-- <img v-bind:src="imageBytes" /> -->
        <div
          class="file-selection-bar"
          style="clear: left"
          v-bind:class="
            report.data_file
              ? 'file-selection-bar_three-col'
              : 'file-selection-bar_two-col'
          "
        >
          <div class="report-title">
            <form class="noFlex" v-on:change="selectReport(selected)">
              <label for="report-date" class="visually-hidden">
                Select a Report
              </label>
              <select name="report-date" id="report-date" v-model="selected">
                <option value="">Select a Report</option>
                <template v-for="report in reports" :key="report.id">
                  <!-- <option v-bind:value="report.id" >{{fixFileName(report.pdf_file_name)}}</option> -->
                  <!-- <option v-bind:value="report.id" >{{ report.issue }}</option> -->
                  <option :value="report.id">
                    {{ momentFormat(report.issue, 'MMMM YYYY') }}
                  </option>
                </template>
              </select>
            </form>
          </div>
          <div class="report-data-file" v-if="report.data_file">
            <span>Data File</span>
            <a :href="'/storage/' + report.data_file" v-if="report.data_file">
              <img :src="'/images/icons/icon-xls.svg'" alt="File" />
            </a>
          </div>
          <div class="report-files">
            <span>Report</span>
            <a
              :href="'/storage/' + report.downloads.doc"
              v-if="report.downloads.doc"
            >
              <img :src="'/images/icons/icon-doc.svg'" alt="File" />
            </a>
            <a
              :href="'/storage/' + report.downloads.xls"
              v-if="report.downloads.xls"
            >
              <img :src="'/images/icons/icon-xls.svg'" alt="File" />
            </a>
            <a
              :href="'/storage/' + report.downloads.pdf"
              v-if="report.downloads.pdf"
              download
            >
              <img :src="'/images/icons/icon-pdf.svg'" alt="File" />
            </a>
          </div>
        </div>
      </div>

      <div v-if="report.downloads.pdf">
        <!-- <google-iframe-embed-component :sourcelink="app_url+ '/storage/' + report.downloads.pdf"></google-iframe-embed-component> -->
        <!-- <embed :src="'//drive.google.com/viewerng/viewer?embedded=true&url='+ app_url+ '/storage/' + report.downloads.pdf" width="100%" height="100%"> -->
        <!-- safarimobile is now all mobile -->
        <template v-if="!safarimobile">
          <div class="iframeEmbed insiderIframe--wrapper" id="google">
            <iframe
              class="insiderIframe"
              :src="'/storage/' + report.downloads.pdf"
            ></iframe>
          </div>
        </template>
        <template v-else>
          <!--use the google renderer-->
          <!-- <p><a :href="'/storage/' + report.downloads.pdf" class="button-green">Download PDF</a></p> -->
          <div class="iframeEmbed insiderIframe--wrapper" id="google">
            <iframe
              :src="
                'https://docs.google.com/viewer?url=' +
                app_url +
                '/storage/' +
                report.downloads.pdf +
                '&embedded=true'
              "
              style="width: 100%; height: 100%"
              frameborder="0"
            ></iframe>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment';
  export default {
    props: {
      report_to_view: {
        type: [String, Number],
        required: true,
      },
      region: {
        type: String,
        required: false,
      },
      app_url: {
        type: String,
        required: false,
      },
    },
    data: function () {
      return {
        loading: true,
        example: '',
        reports: [],
        selected: '', //make this the most recent report
        report: {
          name: '',
          data_file: '',
          downloads: {
            doc: '',
            xls: '',
            pdf: '',
          },
          iframe: '',
        },
        sourcelink: '',
        safarimobile:
          navigator.userAgent.match(/(iPod|iPhone|iPad)/) &&
          navigator.userAgent.match(/AppleWebKit/),
      };
    },
    mounted() {
      this.getReports();
    },
    methods: {
      momentFormat(date, format) {
        return moment(date).format(format);
      },
      //Inital get reports
      getReports: function () {
        var _this = this;
        axios
          .get(
            '/reports/by_report_type_id/' +
              this.report_to_view +
              '/' +
              this.region,
            {
              // params: {
              //  report_type: this.report_to_view
              // }
            }
          )
          .then((success) => {
            _this.reports = success.data.data;
            _this.selectReport(success.data.data[0].id);
          })
          .catch(function (error) {
            // TODO: HANDLE ERROR - This is just silencing the error
          });
      },
      //select report
      selectReport: function (id) {
        var _this = this;
        axios
          .get('/reports/by_id/' + id, {})
          .then((success) => {
            this.report = {
              name: success.data.data.pdf_file_name,
              data_file: success.data.data.data_attachment,
              downloads: {
                doc: success.data.data.doc_attachment,
                xls: success.data.data.xls_attachment,
                pdf: success.data.data.pdf_attachment,
              },
              iframe: '',
            };
            this.selected = id;
            this.loading = false;
          })
          .catch(function (error) {
            // TODO: HANDLE ERROR - This is just silencing the error
          });
      },
      //format filename to remove .pdf
      fixFileName: function (filename) {
        return filename.replace('.pdf', '');
      },
    },
  };
</script>
